import React from 'react';
import './Privacy.css';

function Privacy() {
  return (
    <div className="privacy-page">
      <div className="container">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

        <section>
          <h2>Information We Collect</h2>
          <p>We collect information you provide directly to us, such as when you create an account, use our services, or contact us for support.</p>
          
          <h3>Personal Information</h3>
          <ul>
            <li>Name and contact information</li>
            <li>Account credentials</li>
            <li>Profile information and capabilities</li>
            <li>Location data for helper matching</li>
            <li>Communication preferences</li>
          </ul>
        </section>

        <section>
          <h2>How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide and maintain our services</li>
            <li>Connect farmers with helpers in their area</li>
            <li>Send emergency alerts and notifications</li>
            <li>Improve our platform and user experience</li>
            <li>Communicate with you about your account</li>
          </ul>
        </section>

        <section>
          <h2>Information Sharing</h2>
          <p>We may share your information in the following circumstances:</p>
          <ul>
            <li>With other users when you request or provide help</li>
            <li>With emergency services when necessary</li>
            <li>With service providers who assist our operations</li>
            <li>When required by law or to protect safety</li>
          </ul>
        </section>

        <section>
          <h2>Data Security</h2>
          <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
        </section>

        <section>
          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access and update your personal information</li>
            <li>Delete your account and associated data</li>
            <li>Opt out of non-essential communications</li>
            <li>Request a copy of your data</li>
          </ul>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>If you have questions about this Privacy Policy, please contact us at:</p>
          <p>Email: privacy@herdinghelpers.com<br />
          Phone: (555) 123-4567</p>
        </section>
      </div>
    </div>
  );
}

export default Privacy;